/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BadRequestResponse,
  FailureResponseResponse,
  ForbiddenResponse,
  NotFoundResponse,
  SuccessResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary deactivate cash drawer by ID
 */
export const deactivateCdAccountingLocation = (id: string) => {
  return customInstance<SuccessResponse>({
    url: `/bm-accounting-location/v1/deactivate-cd/${id}`,
    method: 'put',
  });
};

export const getDeactivateCdAccountingLocationMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateCdAccountingLocation>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateCdAccountingLocation>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateCdAccountingLocation>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deactivateCdAccountingLocation(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateCdAccountingLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateCdAccountingLocation>>
>;

export type DeactivateCdAccountingLocationMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary deactivate cash drawer by ID
 */
export const useDeactivateCdAccountingLocation = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateCdAccountingLocation>>,
    TError,
    { id: string },
    TContext
  >;
}) => {
  const mutationOptions = getDeactivateCdAccountingLocationMutationOptions(options);

  return useMutation(mutationOptions);
};
